import React from "react";
import { useState, useEffect } from "react";
import { LuCalendarCheck } from "react-icons/lu";
import ReactTooltip from "react-tooltip";
import { Alert, Button, Col, Row, UncontrolledAlert } from "reactstrap";
import axios from "../../../../axios";
import {
  LayoutHeadingShadow,
  LayoutHeadingShadowLeft,
  LayoutRowShadow,
} from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import { toastContainer } from "../../../../utils/toast";
import * as url from "../../../../utils/url";
import DaniContainer from "../../../dani/DaniContainer";
import DaniHeader from "../../../dani/DaniHeader";
import { LayoutData } from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actionCreators from "../../../../modules/actions";
import parse from "react-html-parser";
import {
  BiCheckbox,
  BiCheckboxChecked,
  BiLinkExternal,
  BiX,
} from "react-icons/bi";
import { BsDash } from "react-icons/bs";
import TrivvyCreateSteps from "./LoaderBoxSteps";
import SupportedLanguagesText from "../../../../components/Trivvy/SupportedLanguagesText";
import { splitStringIntoChunks, splitStringIntoQuestions } from "../../data";
import "./loaderbox-bwai.css";

function CreateTrivvyLoaderBox({
  loaderApiData,
  user,
  setCreateTrivvyLoader,
  createTrivvyLoader,
  setImportTemplateAddedTrivvys,
  ...props
}) {
  const [trivvysGenerated, setTrivvysGenerated] = useState(false);
  const [trivviesData, setTrivviesData] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);

  const [loadingSteps, setLoadingSteps] = useState([
    {
      stepNumber: 1,
      stepText: "Uploading content",
    },
    {
      stepNumber: 2,
      stepText: "Reading through content",
    },
    {
      stepNumber: 3,
      stepText: "Understanding context",
    },

    {
      stepNumber: 4,
      stepText: "Creating trivvys",
    },
  ]);

  const renderContentHtml = (content, contentType) => {
    if (content) {
      if (contentType == "TEXT") {
        return parse(
          `<div>Reading through "<span style={{wordBreak:"break-all"}}>${
            content.length > 50 ? `${content.slice(0, 50)}...` : content
          }</span>"</div>`
        );
      } else {
        return parse(
          `<div>Reading through <a href="${content}" style={{wordBreak:"break-all"}} target="_blank">${
            content.length > 50 ? `${content.slice(0, 50)}...` : content
          }</a></div>`
        );
      }
    } else {
      return "Reading through content...";
    }
  };

  const changeStepText = (index, newText) => {
    const stepsArr = [...loadingSteps];

    stepsArr[index].stepText = newText;

    setLoadingSteps(stepsArr);
  };

  const toastError = (error, step) => {
    if (
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors.message
    ) {
      if (error.response.data.errors.message == "invalid_translation_plan") {
        toastContainer(
          <SupportedLanguagesText invalidTranslationPlan />,
          "error"
        );
      } else if (
        error.response.data.errors.message ==
        "translation_language_not_available"
      ) {
        toastContainer(
          <SupportedLanguagesText noTranslationLanguage />,
          "error"
        );
      } else {
        toastContainer(
          error.response.data.errors.message || "Server error occured",
          "error"
        );
      }
    } else {
      if (step === 1) {
        toastContainer("Error occured while uploading content", "error");
      } else {
        toastContainer("Error occured while generating questions", "error");
      }
    }
  };

  useEffect(() => {
    console.log('loaderApiData ---- ', loaderApiData)
    if (loaderApiData) {
      try {
        
      
      setTrivviesData(loaderApiData.trivvyPartsArray);
      setCurrentStep(1);
      const newPayload = {
        ...loaderApiData.payload,
      };

      console.log('138 newPayload --- ', newPayload)

      const hasFile =loaderApiData.triviaForm && loaderApiData.triviaForm.has("document");

      const noOfQuestions =
        loaderApiData.payload.noOfTrivvys *
        loaderApiData.payload.questionsCount;
      const noOfTrivvys = loaderApiData.payload.noOfTrivvys;
 
      const runCreationStep = (ai_questions, dataToStore) => {
        setCurrentStep(4);
        axios
          .post(url.createTrivvysFinal, { ai_questions, dataToStore })
          .then(({ data }) => {
            setCurrentStep(5);
            setCreateTrivvyLoader({
              ...createTrivvyLoader,
              loaderApiData: null,
            });

            setTrivviesData(data.data);

            if (props.location.pathname.indexOf("/list") >= 0) {
              setImportTemplateAddedTrivvys(data.data);
            }
            setTrivvysGenerated(true);
          })
          .catch((err) => {
            setCreateTrivvyLoader({
              display: false,
              loaderApiData: null,
              minimize: false,
            });
            toastContainer("Error occured while scheduling trivvys", "error");
          });
      };

      const runQuestionsStep = async(apiData, upload_text) => {
        changeStepText(0, "Uploaded content");
        setCurrentStep(2);

        const total_questions_to_generate =
          apiData.questionsCount * apiData.noOfTrivvys;

        if (total_questions_to_generate <= 5) {
          console.log('inside total quesiton API call 183')
          axios
            .post(url.readContentAndCreateQuestions, {
              totalQuestionsToGenerate: total_questions_to_generate,
              upload_text,
              existingQuestions: [],
              difficultyLevel: apiData.difficultyLevel,
              trivvyLanguage: apiData.trivvyLanguage,
              dataToStore:apiData,
              preventDuplicates: apiData.uploadType === 1,
              ...apiData
            })
            .then(({ data }) => {
              setCurrentStep(3);
              setTimeout(() => {
                const { ai_questions, dataToStore } = data.data;
                const dateToStoreUpdated = {
                  ...dataToStore,
                   triviaCategoryType: "KNOWLEDGE_CHECK"
                };
                runCreationStep(ai_questions, dateToStoreUpdated);
              }, 3000);
            })
            .catch((error) => {
              toastError(error);
              setCreateTrivvyLoader({
                display: false,
                loaderApiData: null,
                minimize: false,
              });
            });
        } else {
          let question_array = [];
          let dataToStoreCopy = null
          // No local text to split -- let each part's own BE call re-extract
          // it (like the <=5 branch already relies on) instead of giving up.
          const textChunks = upload_text
            ? splitStringIntoChunks(upload_text, apiData.noOfTrivvys)
            : new Array(apiData.noOfTrivvys).fill(upload_text);
          
          const promiseMap = await textChunks.map((item,idx) =>{
            return new Promise(async(resolve,reject)=>{
              setTimeout(() => {
                axios
                .post(url.readContentAndCreateQuestions, {
                  totalQuestionsToGenerate: apiData.questionsCount,
                  upload_text:item,
                  existingQuestions: question_array,
                  difficultyLevel: apiData.difficultyLevel,
                  trivvyLanguage: apiData.trivvyLanguage,
                  dataToStore:apiData,
                  preventDuplicates: apiData.uploadType === 1,
                  ...apiData,
                })
                .then(({ data }) => {
                  setCurrentStep(3);
             
                    const { ai_questions, dataToStore } = data.data;
                    dataToStoreCopy = dataToStore;
                   
                    resolve(ai_questions)

                })
                .catch((error) => {
                 
                  reject(error)
                });
              }, idx*1000);
           
            })
          })

          await Promise.all(promiseMap).then(data=>{
            for (const iterator of data) {
              question_array = [...question_array,...iterator]
            }
            const dataToStoreCopyUpdated = dataToStoreCopy
              ? { ...dataToStoreCopy, triviaCategoryType: "KNOWLEDGE_CHECK" }
              : dataToStoreCopy;
            runCreationStep(question_array, dataToStoreCopyUpdated);
          }).catch((error) => {
              toastError(error);
              setCreateTrivvyLoader({
                display: false,
                loaderApiData: null,
                minimize: false,
              });
            });
        }


     
      };

      if (hasFile) {
        console.log('265 --- HAS FILE')
        axios
          .post(url.uploadDocumentForTrivvy, loaderApiData.triviaForm)
          .then(({ data }) => {
            const upload_url = data.data.uploadUrl;
            const upload_file_name = data.data.uploadFileName;
            newPayload.s3Key =  data.data.s3Key
            newPayload.uploadUrl = upload_url;
            newPayload.uploadFileName = upload_file_name;
            newPayload.trivvyLanguage = data.data.trivvyLanguage;
            newPayload.contentType = data.data.contentType
            newPayload.etag = data.data.etag
            const content =
              newPayload.uploadType == 2
                ? newPayload.uploadText
                : newPayload.uploadUrl;

            const contentType = newPayload.uploadType == 2 ? "TEXT" : "LINK";
            console.log('202 contentType --- ', contentType)
            axios
              .post(url.readContentForTrivvy, newPayload)
              .then(({ data }) => {
                const { upload_text, dataToStore } = data.data;
                changeStepText(1, renderContentHtml(content, contentType));
                runQuestionsStep(dataToStore, upload_text);
              })
              .catch((error) => {
                toastError(error);
                setCreateTrivvyLoader({
                  display: false,
                  loaderApiData: null,
                  minimize: false,
                });
              });
          })
          .catch((error) => {
            toastError(error);
            setCreateTrivvyLoader({
              display: false,
              loaderApiData: null,
              minimize: false,
            });
          });
      } else {
        console.log('testing --- 308')
        runQuestionsStep(newPayload, newPayload.uploadText);
        const content =
          newPayload.uploadType == 2
            ? newPayload.uploadText
            : newPayload.uploadUrl;
        const contentType = newPayload.uploadType == 2 ? "TEXT" : "LINK";

        changeStepText(1, renderContentHtml(content, contentType));
      }
      } catch (error) {
        console.error(error,'error')
        
      }
    }
  }, []);

  return (
    <div
      className={
        trivvysGenerated ? 'bwai-loader-box trivvysGenerated' : 'bwai-loader-box'
      }>
      <DaniContainer
        height={480}
        width={450}
        opened={true}
        minimized={createTrivvyLoader.minimize}
        solid={true}
      >
        <DaniHeader
          trivvysGenerated={trivvysGenerated}
          style={{
            backgroundColor: trivvysGenerated ? "#d4edda" : "",
          }}
        >
          <div
            className="text-center font-weight-bold"
            style={{ color: "black", width: "80%", fontSize: "1.1em" }}
          >
            {trivvysGenerated ? (
              <span style={{ color: "#073d13 !important" }}>
                Completed <BiCheckboxChecked />{" "}
              </span>
            ) : (
              "Generating trivvys"
            )}
          </div>
          <div
            className="cursor-pointer ml-2"
            style={{ color: "black" }}
            onClick={() => {
              setCreateTrivvyLoader({
                ...createTrivvyLoader,
                minimize: !createTrivvyLoader.minimize,
              });
            }}
          >
            {createTrivvyLoader.minimize ? <BiLinkExternal /> : <BsDash />}
          </div>
          <div
            className="cursor-pointer ml-2"
            style={{ color: "black" }}
            onClick={() => {
              setCreateTrivvyLoader({
                display: false,
                loaderApiData: null,
                minimize: false,
              });
            }}
          >
            <BiX />
          </div>
        </DaniHeader>

        {!createTrivvyLoader.minimize ? (
          <div>
            <div>
              {!trivvysGenerated && (
                <UncontrolledAlert color="primary">
                  Trivvys are being generated, You can navigate away from the
                  page.
                </UncontrolledAlert>
              )}

              {!trivvysGenerated && (
                <TrivvyCreateSteps
                  currentStep={currentStep}
                  steps={loadingSteps}
                />
              )}

              <div className="mt-1">
                {trivviesData && trivviesData.length ? (
                  <div className="px-1">
                    <div
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "0 20px",
                        minHeight: "200px",
                      }}
                    >
                      {trivviesData.map((item, index) => {
                        let itm_color = index % 2 == 0 ? "#ff6233" : "#c6ffe7";
                        return (
                          <LayoutRowShadow>
                            <LayoutData colWidth={6} className="cursor-pointer">
                              <div
                                data-tip={item.name}
                                className="d-flex align-items-center"
                              >
                                <span
                                  className="trivia-list-item-color-chip"
                                  style={{ backgroundColor: itm_color }}
                                />

                                <span
                                  style={{ display: "block" }}
                                  className="survey-item-title d-block"
                                >
                                  {item.name}
                                </span>
                              </div>
                              <ReactTooltip />
                            </LayoutData>

                            <LayoutData className="text-center" colWidth={4}>
                              {" "}
                              <div className="survey-createddate-text">
                                {item.scheduledDate ? (
                                  <span>
                                    <div>
                                      {moment(item.scheduledDate).format(
                                        "MMM DD, YYYY"
                                      )}
                                    </div>
                                  </span>
                                ) : (
                                  <div className="text-center">
                                    <LuCalendarCheck size={23} color="gray" />
                                  </div>
                                )}
                              </div>
                            </LayoutData>

                            <LayoutData className="text-center" colWidth={2}>
                              {!trivvysGenerated ? (
                                <span className="trivvy-loader mx-auto" />
                              ) : (
                                <Button
                                  onClick={() => {
                                    if (props.history) {
                                      props.history.push(
                                        `/home/trivia/${item.organizationId}/edit/${item._id}/edit`
                                      );
                                    }
                                  }}
                                  size="sm"
                                  className="trivia-action-button-main"
                                >
                                  {" "}
                                  View{" "}
                                </Button>
                              )}
                            </LayoutData>
                          </LayoutRowShadow>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </DaniContainer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    createTrivvyLoader: state.trivia.createTrivvyLoader || { display: false },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCreateTrivvyLoader: (data) =>
      dispatch(actionCreators.setCreateTrivvyLoader(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateTrivvyLoaderBox, axios));
